import { KTSVG } from '_metronic/helpers'

const Filter: React.FC = () => {
  return (
    <div
      id='kt_user_list_filter'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_user_list_filter_toggle'
      data-kt-drawer-close='#kt_user_list_filter_close'>
      <div className='card w-100 rounded-0'>
        <div className='card-header pe-5'>
          <div className='card-title'>
            {/* begin:: Title */}
            <div className='d-flex justify-content-center flex-column me-3'>
              <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                Filter
              </span>
            </div>
            {/* end:: Title */}
          </div>

          <div className='card-toolbar'>
            {/* begin:: Close Button */}
            <button
              className='btn btn-sm btn-bg-white btn-active-light-danger text-center'
              id='kt_user_list_filter_close'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr015.svg'
                className='svg-icon svg-icon-2x mx-auto'
              />
            </button>
            {/* end:: Close Button */}
          </div>
        </div>

        <div className='card-body'>
          <div
            data-kt-element='messages'
            data-kt-scroll='true'
            data-kt-scroll-activate='{default: false, lg: true}'
            data-kt-scroll-max-height='auto'
            data-kt-scroll-offset='5px'>
            <div className='row gy-5'>
              {/* begin:: Name */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>Name</div>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='Search by Name'
                />
              </div>
              {/* end:: Name */}

              {/* begin:: Email */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>Email</div>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='Search by Email'
                />
              </div>
              {/* end:: Email */}

              <div className='col-12 d-flex flex-row'>
                <button className='btn btn-sm btn-primary me-4 w-50 fw-bold'>Search</button>
                <button className='btn btn-sm btn-danger w-50 fw-bolder'>Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter
